import React from 'react';
import { Container, Typography, Box, Toolbar } from '@mui/material';
import Header from '../components/Header';

export default function PolicyPage() {
  return (
    <>
      <Header />
      <Toolbar />
      <Container maxWidth="md" sx={{ mt: 8 }}>
        <Box
          sx={{
          backdropFilter: 'blur(10px)',
          textAlign: 'center',
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#3f51b5' }}>
            事業背景
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
            世間では新型コロナの影響でテレワーク化が進みパソコンの普及率は向上しています。<br/>
            一方当社のユーザーにあたる飲食店ではパソコンの普及率は低いのが現状です。<br/>
            現状での発注システムはパソコンありきとすることで構築されているものばかりです。 <br/>
            弊社で開発してきたシステムもパソコンに依存している部分がまだまだ大きな割合です。<br/>
            またこの発注システムだけでは収益を上げることが出来ておりません。
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
            そこでこの度、外部ツールであった発注システムを新たにスマホで行えるように開発し、<br/>
            弊社で自販以東できた発注側システムのノウハウをパッケージ化し商品として販売していくことを目指します。<br/>
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
            既存の外部ツール（発注側）では様々な制限があり、食品卸業界では使いにくいものでした。<br/>
            一方発注側においてもFAXや電話注文で処理しているケースも多く<br/>
            ピック表や納品伝票を作成するにも多大な時間と人件費がかかるのが現状です。<br/>
          </Typography>
        </Box>
      </Container>
    </>
  );
}
